import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowRight, ArrowLeft, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure link to set a new one.">
      {sent ? (
        <div className="space-y-6">
          <div data-testid="forgot-sent" className="flex gap-3 text-sm text-stone-700 bg-emerald-50 border border-emerald-200 rounded-xl p-4">
            <CheckCircle size={20} weight="fill" className="text-emerald-600 shrink-0" />
            <span>If an account exists for <b>{email}</b>, a reset link is on its way. The link expires in 30 minutes.</span>
          </div>
          <Link data-testid="forgot-back" to="/login" className="inline-flex items-center gap-1.5 text-sm text-stone-500 hover:text-[#C2410C] transition-colors duration-200">
            <ArrowLeft size={15} /> Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wider text-stone-500">Email</Label>
            <Input data-testid="forgot-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-1 rounded-xl" placeholder="you@company.com" />
          </div>
          {error && <div data-testid="forgot-error" className="text-sm text-rose-600 bg-rose-50 border border-rose-200 px-3 py-2 rounded-xl">{error}</div>}
          <Button data-testid="forgot-submit" type="submit" disabled={loading}
            className="w-full rounded-xl bg-[#C2410C] hover:bg-[#9A3412] transition-colors duration-200 gap-2">
            {loading ? "Sending…" : "Send reset link"} <ArrowRight size={16} />
          </Button>
          <Link data-testid="forgot-back" to="/login" className="inline-flex items-center gap-1.5 text-sm text-stone-500 hover:text-[#C2410C] transition-colors duration-200">
            <ArrowLeft size={15} /> Back to sign in
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
